import { z } from 'zod';
/**
 * Staff = пользователь с ролью MANAGER / ADMIN / AUDITOR.
 * Создаётся только администратором через POST /admin/staff.
 */
export const staffRoleSchema = z.enum(['MANAGER', 'ADMIN', 'AUDITOR']);
export const createStaffSchema = z.object({
    email: z.string().email('Некорректный email').max(255),
    /** Временный пароль. Минимум 8 символов: цифра, заглавная, спецсимвол. */
    password: z
        .string()
        .min(8, 'Минимум 8 символов')
        .max(128)
        .refine((v) => /[A-ZА-Я]/.test(v), 'Хотя бы одна заглавная буква')
        .refine((v) => /\d/.test(v), 'Хотя бы одна цифра')
        .refine((v) => /[^A-Za-zА-Яа-я0-9]/.test(v), 'Хотя бы один спецсимвол'),
    fullName: z.string().min(2, 'ФИО обязательно').max(255),
    phone: z.preprocess((v) => {
        if (v === null || v === undefined)
            return null;
        if (typeof v !== 'string')
            return v;
        const t = v.trim();
        return t === '' ? null : t;
    }, z.string().max(50).nullable()),
    role: staffRoleSchema,
});
export const setStaffActiveSchema = z.object({
    isActive: z.boolean(),
});
/** Редактирование сотрудника: всё необязательно (PATCH-семантика). */
export const updateStaffSchema = z.object({
    email: z.string().email('Некорректный email').max(255).optional(),
    fullName: z.string().min(2, 'ФИО обязательно').max(255).optional(),
    phone: z
        .preprocess((v) => {
        if (v === null || v === undefined)
            return null;
        if (typeof v !== 'string')
            return v;
        const t = v.trim();
        return t === '' ? null : t;
    }, z.string().max(50).nullable())
        .optional(),
    role: staffRoleSchema.optional(),
    /** Право менеджера действовать от имени клиента (правка клиента, поручения). */
    canActForClients: z.boolean().optional(),
});
/** Сброс пароля админом. Те же правила силы что и в create. */
export const resetStaffPasswordSchema = z.object({
    password: z
        .string()
        .min(8, 'Минимум 8 символов')
        .max(128)
        .refine((v) => /[A-ZА-Я]/.test(v), 'Хотя бы одна заглавная буква')
        .refine((v) => /\d/.test(v), 'Хотя бы одна цифра')
        .refine((v) => /[^A-Za-zА-Яа-я0-9]/.test(v), 'Хотя бы один спецсимвол'),
});
export const staffDtoSchema = z.object({
    id: z.string(),
    email: z.string(),
    role: staffRoleSchema,
    fullName: z.string().nullable(),
    phone: z.string().nullable(),
    isActive: z.boolean(),
    /** Право действовать от имени клиента (актуально для MANAGER). */
    canActForClients: z.boolean(),
    createdAt: z.string().datetime(),
    lastLoginAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=admin-staff.js.map